import Crud from "../components/ThemeCategory/Crud.vue";
import Add from "../components/ThemeCategory/Add.vue";
import Edit from "../components/ThemeCategory/Edit.vue";

let routes = {
    path: "/theme-categories",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/theme-categories",
            name: "Categorias de Temas",
            component: Crud
        },
        {
            path: "/theme-categories/add",
            name: "Nova Categoria",
            component: Add
        },
        {
            path: "/theme-categories/edit/:id",
            name: "Editar Categoria",
            component: Edit
        }
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/theme_category.js